export default __webpack_public_path__ + "static/media/kristina-flynn.c6064883.jpeg";